// extracted by mini-css-extract-plugin
export default {"labels":"VisualizzazineAnonima_labels__k4f6R"};